<template>
  <loading-content :loading="loading">
    <v-data-table-server
      :headers="headers"
      :items="entries"
      :loading="loading"
      :items-length="count"
      v-model:items-per-page="itemsPerPage"
      v-model:page="page"
      :items-per-page-options="itemsPerPageOptions"
    >
      <template v-slot:[`item.creator`]="{ item }">
        {{item.creator.fullName}}
      </template>
      <template v-slot:[`item.object`]="{ item }">
        <span>{{item.object}}</span>
      </template>
      <template v-slot:[`item.description`]="{ item }">
        <a href="#" @click="viewEvent(item.calendarModel)" v-if="item.calendarModel">{{eventPeriod(item.calendarModel)}}</a>
        <div v-html="textToHtml(item.description)" />
      </template>
    </v-data-table-server>
    <v-dialog v-model="selectedEvent" max-width="700px">
      <event mode="view" :eventId="selectedEventId" @close="selectedEvent = false" />
    </v-dialog>
  </loading-content>
</template>

<script>
import api from '@/api'
import { mapActions } from 'vuex'
import { pickBy } from 'lodash'
import helpersMixin from '@/plugins/helpersMixin'
import listMixin from '@/plugins/listMixin'
import { textToHtml } from '@/plugins/sanitize'

export default {
  mixins: [ helpersMixin, listMixin ],
  props: {
    objectId: {
      required: false
    },
    clientId: {
      required: false
    }
  },
  data () {
    return {
      selectedEvent: false,
      selectedEventId: null,
      entries: [],
      headers: [{
        title: 'Kuupäev',
        align: 'start',
        value: 'dateCreated',
        sortable: false
      }, {
        title: 'Kasutaja',
        align: 'start',
        value: 'creator',
        sortable: false
      }, {
        title: 'Tegevus',
        align: 'start',
        value: 'typeInfo.title',
        sortable: false
      }, {
        title: 'Tüüp',
        align: 'start',
        value: 'object',
        sortable: false
      }, {
        title: 'Kirjeldus',
        align: 'start',
        value: 'description',
        sortable: false
      }]
    }
  },
  watch: {
    params: {
      handler() {
        this.refresh()
      },
      deep: true
    }
  },
  computed: {
    params () {
      return pickBy({
        objectId: this.objectId,
        clientId: this.clientId,
        limit: this.itemsPerPage,
        offset: (this.page - 1) * this.itemsPerPage,
        ...this.search
      }, v => v !== undefined)
    }
  },
  methods: {
    ...mapActions(['showNotification']),
    textToHtml,
    async refresh () {
      this.loading = true
      try {
        const { entries, count } = await api.getHistory(this.params)
        this.entries = entries
        this.count = count
      } catch (err) {
        this.showNotification({ text: err.message, color: 'red' })
      }
      this.loading = false
    },
    viewEvent (event) {
      this.selectedEventId = event.id
      this.selectedEvent = true
    }
  },
  mounted () {
    this.refresh()
  }
}
</script>